import { Table } from "@mantine/core";
import { EmptyState } from "../EmptyState/EmptyState";
import classes from "./tableNoResults.module.scss";

/**
 * Reusable empty-state row for Mantine tables.
 *
 * Renders a single full-width `<Table.Tr>` to be placed inside a
 * `<Table.Tbody>`, e.g.
 *
 *   <Table.Tbody>
 *     <TableNoResults colSpan={columns.length} />
 *   </Table.Tbody>
 *
 * @param {number} colSpan     Number of columns to span (use the table's column count).
 * @param {string} [message]   Optional override text. Defaults to EmptyState's default.
 */
export function TableNoResults({ colSpan = 1, message }) {
  return (
    <Table.Tr className={classes["no-results-row"]}>
      <Table.Td colSpan={colSpan}>
        <EmptyState message={message} />
      </Table.Td>
    </Table.Tr>
  );
}

export default TableNoResults;
